import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { setCurrentPlanningReport } from '../../../../redux/planning/Actions';

import withStyles from '@material-ui/core/styles/withStyles';
import { Box, IconButton, Tooltip, Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import InfoIcon from '@material-ui/icons/Info';
import PlanningAlertIcon from '@material-ui/icons/NotificationImportant';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import PanelHeader from '../PanelHeader';
import { Link } from 'react-router-dom';

class PlanningHeader extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        isCompact: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        // Redux State
        currentPlanningReport: PropTypes.object,
        // Redux Dispatch
        dispatchSetCurrentPlanningReport: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.back = this.back.bind(this);
    }

    back () {
        const { dispatchSetCurrentPlanningReport } = this.props;
        dispatchSetCurrentPlanningReport(null);
    }

    render () {
        const { classes, isCompact, onClick, currentPlanningReport } = this.props;

        return (
            <PanelHeader
                isCompact={isCompact}
                isExpandable={true}
                onClick={onClick}
            >
                { !currentPlanningReport && <PlanningAlertIcon /> }
                {
                    currentPlanningReport && <IconButton
                        size="small"
                        onClick={this.back}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                }
                <Typography
                    variant="h4"
                    color="textPrimary"
                >
                    { currentPlanningReport ? currentPlanningReport.name : 'Planning Alerts' }
                </Typography>
                <Typography
                    variant="h4"
                    color="secondary"
                >
                    [BETA]
                </Typography>
                <Link to={'/dashboard/planning'}>
                    <Tooltip arrow title="View Planning Alerts on Dashboard" placement="right">
                        <Box color="primary.light">
                            <IconButton
                                color="inherit"
                                onClick={() => {}}
                            >
                                <ExitToAppIcon />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Link>
            </PanelHeader>
        );
    }
}

const style = theme => ({

});

const mapStateToProps = (state, ownProps) => {
    const reducer = state.planningReducer;
    const report = reducer.planningReports.find(report => report.id === reducer.currentPlanningReportId);

    return {
        currentPlanningReport: report
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchSetCurrentPlanningReport: (id) => dispatch(setCurrentPlanningReport(id))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(PlanningHeader);